'use es6';

import UserMessage from 'MeetingsLib/models/UserMessage';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
export function showUserMessage(_ref) {
  var type = _ref.type,
      content = _ref.content;
  return {
    type: ActionTypes.SHOW_USER_MESSAGE,
    userMessage: UserMessage({
      type: type,
      content: content
    })
  };
}
export function toggleTroubleshootMode(active) {
  return {
    type: ActionTypes.TOGGLE_TROUBLESHOOT_MODE,
    active: active
  };
}